import { render } from "./Pagination.vue?vue&type=template&id=99800e1c&scoped=true"
import script from "./Pagination.vue?vue&type=script&lang=js"
export * from "./Pagination.vue?vue&type=script&lang=js"

import "./Pagination.vue?vue&type=style&index=0&id=99800e1c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99800e1c"],['__file',"src/components/elements/Pagination.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "99800e1c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('99800e1c', __exports__)) {
    api.reload('99800e1c', __exports__)
  }
  
  module.hot.accept("./Pagination.vue?vue&type=template&id=99800e1c&scoped=true", () => {
    api.rerender('99800e1c', render)
  })

}


export default __exports__